import { Login } from './Login'

export function Signup() {
  return <Login initialMode="signup" />
} 